import * as angular from "angular";
import "angular-ui-router";
import "angular-ui-bootstrap";
import "angular-resource";
import "angular-animate";
import "angular-sanitize";
import "ui-select";
import "ng-file-upload";

import {HeaderComponent} from "./components/header/HeaderComponent";
import {FooterComponent} from "./components/footer/FooterComponent";
import {BreadcrumbComponent} from "./components/breadcrumb/BreadcrumbComponent"
import {MainAppComponent} from "./components/mainApp/MainAppComponent";
import {ActivityStreamModalComponent} from "./components/activity/ActivityStreamModalComponent";
import {HttpInterceptor} from "./core/services/HttpInterceptor";
import {Scroll} from "./core/directives/Scroll"
import {config} from "./configs"
angular.module("app.main", ["ui.router", "ui.bootstrap", "ui.select", "ngResource", "ngAnimate", "ngFileUpload", "ngSanitize"])
    .component("mainApp", new MainAppComponent())
    .component("header",  new HeaderComponent())
    .component("footer", new FooterComponent())
    .component("breadcrumb", new BreadcrumbComponent())
    .component("activityModal", new ActivityStreamModalComponent())
    .service("httpInterceptor", HttpInterceptor)
    .directive("scroll", () => new Scroll())
    .config(config);
